module.exports = __webpack_public_path__ + "img/folder_icn.1d0c69be.svg";